import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface ITableDescriptionParams {
  id: string;
  description: string;
}

export class SetTableDescriptionRequest extends Request<ITableDescriptionParams, IResult> {
  constructor(params: ITableDescriptionParams) {
    super('setTableDescription', params);
  }
}
